import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import Icon from '@divvy-web/skylab.icon'
import TextLink from '@divvy-web/skylab.textlink'

import styles from './styles.module.scss'

interface EligibleOfferTileLearnMoreLinkProps {
  url: string
  onClick?: () => void
}

const EligibleOfferTileLearnMoreLink = ({ url, onClick }: EligibleOfferTileLearnMoreLinkProps) => {
  const [getClassName] = useNameFormatter('EligibleOfferTileLearnMoreLink')

  return (
    <span className={styles[getClassName('')]}>
      <TextLink
        href={url}
        target='_blank'
        onClick={onClick}
      >
        <FormattedMessage
          defaultMessage='Learn more'
          id='sputnik.EligibleOfferTileLearnMoreLink__TdTXXf'
        />
        <Icon name='external-link' />
      </TextLink>
    </span>
  )
}

export default EligibleOfferTileLearnMoreLink
